"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamWithRelsSchema = exports.TeamSchema = void 0;
const zod_1 = require("zod");
const gender_1 = require("./gender");
exports.TeamSchema = zod_1.z.object({
    team_id: zod_1.z.number().int().positive(),
    name: zod_1.z.string(),
    nickname: zod_1.z.string().nullable(),
    area_code: zod_1.z.string().nullable(),
    gender: gender_1.GenderSchema,
});
exports.TeamWithRelsSchema = exports.TeamSchema.pick({
    team_id: true,
    name: true,
    nickname: true,
    area_code: true,
    gender: true,
}).extend({
    cycle_ids: zod_1.z.number().int().positive().array(),
});
//# sourceMappingURL=team.js.map